import { combineReducers } from "@reduxjs/toolkit";
import someReducer from "./someReducer"; 

const rootReducer = combineReducers({
  someState: someReducer,
});

export default rootReducer;